// extracted by mini-css-extract-plugin
export default {"header":"header_header__kndob","logo":"header_logo__y44MP","user":"header_user__qmUI2","userAvatar":"header_userAvatar__PGQWL","loginButton":"header_loginButton__EFMRe"};